/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomDetailCategory {
    TAX_RESIDENCY = 'TAX_RESIDENCY',
    FATCA = 'FATCA',
    CRS = 'CRS',
    GDPR = 'GDPR',
}
